import Box from '@mui/material/Box';


export const Explainer = () => {
  return (
    <Box
      sx={{ aspectRatio: '16 / 9' }}
      my={6}
      bgcolor="white"
      borderRadius="15px"
      position="relative"
      flexGrow={1}
      overflow="hidden"
    >
      <video height="100%" width="100%" controls>
        <source src="/video/LGCY%20Pet%20Hopeling.mp4" type="video/mp4"/>
      </video>
    </Box>
  );
};